import { render } from "./MenuPurchase.vue?vue&type=template&id=6c61a697&scoped=true"
import script from "./MenuPurchase.vue?vue&type=script&lang=js"
export * from "./MenuPurchase.vue?vue&type=script&lang=js"

import "./MenuPurchase.vue?vue&type=style&index=0&id=6c61a697&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c61a697"]])

export default __exports__